export default __webpack_public_path__ + "static/media/active-marker-circle.c604d925.svg";